import PageLoadBoundary from './PageLoadBoundary';

export default PageLoadBoundary;
